<script lang="ts" setup>
useSeoMeta({
  ogImage: '/favicon-thumbnail.png',
  twitterTitle: 'Vocal',
  twitterDescription: 'Easily share voice messages',
  twitterImage: '/favicon-thumbnail.png',
  twitterCard: 'summary_large_image'
})

useFavicon('/icons/logo-128.png')
</script>

<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="#267EFA" :height="4" />
    <NuxtPage />
  </NuxtLayout>
</template>

<style lang="sass">
.page-transition-fade
  &-enter-active,
  &-leave-active
    transition: opacity 250ms

  &-enter-from,
  &-leave-to
    opacity: 0
</style>
